//@flow

import * as React from "react"
import styled from "styled-components"
import { TweenMax, TimelineMax, Linear, Cubic } from "gsap"

import cloud1 from "./cloud1@2x.png"
import cloud2 from "./cloud2@2x.png"
import cloud3 from "./cloud3@2x.png"
import cloud4 from "./cloud4@2x.png"
import cloud5 from "./cloud5@2x.png"
import cloud6 from "./cloud6@2x.png"

type Props = { zIndex?: number, hidden: boolean }
type State = {}

const Cloud = styled.img`
  display: block;
  position: absolute;
  top: 0;
  left: 0;
`

const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 980px;
  width: 1920px;
  overflow: hidden;
  z-index: ${props => props.zIndex || 0};
`
/**
 * Due to performance reasons on browsers other than Chrome, at this
 * time we'll use a duplicate version of the SVG clouds component that
 * utilizes rasterized PNG images. Note: The animation of this component
 * is slightly different from the original SVG based clouds due to
 * subsequent revisions.
 */
class CloudsRasterized extends React.Component<Props, State> {
  cloud1: ?HTMLElement
  cloud2: ?HTMLElement
  cloud3: ?HTMLElement
  cloud4: ?HTMLElement
  cloud5: ?HTMLElement
  cloud6: ?HTMLElement
  timeline: ?TimelineMax

  constructor(props: Props, state: State) {
    super(props)
  }

  componentDidMount() {
    const horizontalOffset = 2220
    const verticalOffset = 0
    const clouds = [
      this.cloud1,
      this.cloud2,
      this.cloud4,
      this.cloud5,
      this.cloud6,
      this.cloud3
    ]

    TweenMax.set(clouds, { scale: 0.5 })

    TweenMax.set(this.cloud1, {
      x: horizontalOffset + 40,
      y: verticalOffset + 310,
      opacity: 0
    })
    TweenMax.set(this.cloud2, {
      x: horizontalOffset + -300,
      y: verticalOffset + 220,
      opacity: 0
    })

    TweenMax.set(this.cloud6, {
      x: horizontalOffset + 1660,
      y: verticalOffset + 190,
      opacity: 0
    })
    TweenMax.set(this.cloud5, {
      x: horizontalOffset + 1150,
      y: verticalOffset + 250,
      opacity: 0
    })

    TweenMax.set(this.cloud3, {
      x: -horizontalOffset + 280,
      y: verticalOffset + 280,
      opacity: 0
    })
    TweenMax.set(this.cloud4, {
      x: -horizontalOffset + 1200,
      y: verticalOffset + 230,
      opacity: 0
    })

    TweenMax.staggerTo(
      clouds,
      2,
      { opacity: 1, ease: Linear.easeOut, delay: 1 },
      1
    )

    const duration = 60

    const timeline = new TimelineMax({ repeat: -1, delay: 1 })
    timeline.to(
      this.cloud1,
      duration,
      {
        x: `-=${horizontalOffset * 2.15}`,
        ease: Linear.easeNone
      },
      0
    )
    timeline.to(
      this.cloud5,
      duration,
      {
        x: `-=${horizontalOffset * 2.5}`,
        ease: Linear.easeNone
      },
      0
    )
    timeline.to(
      this.cloud6,
      duration,
      {
        x: `-=${horizontalOffset * 2.15}`,
        ease: Linear.easeNone
      },
      0
    )
    timeline.to(
      this.cloud2,
      duration,
      {
        x: `-=${horizontalOffset * 2.5}`,
        ease: Linear.easeNone
      },
      0
    )
    timeline.to(
      this.cloud3,
      duration,
      {
        x: `+=${horizontalOffset * 1.8}`,
        ease: Linear.easeNone
      },
      0
    )
    timeline.to(
      this.cloud4,
      duration,
      {
        x: `+=${horizontalOffset * 1.8}`,
        ease: Linear.easeNone
      },
      0
    )
    timeline.progress(0.25)
    this.timeline = timeline
  }

  componentDidUpdate(prevProps: Props) {
    const { hidden } = this.props
    if (hidden !== prevProps.hidden) {
      hidden ? this.raiseClouds() : this.lowerClouds()
    }
  }

  raiseClouds() {
    TweenMax.staggerTo(
      [this.cloud1, this.cloud2, this.cloud5, this.cloud6],
      1,
      {
        y: "+=50",
        ease: Cubic.easeInOut
      },
      0.1
    )
  }

  lowerClouds() {
    TweenMax.staggerTo(
      [this.cloud1, this.cloud2, this.cloud5, this.cloud6],
      1,
      {
        y: "-=50",
        alpha: 1,
        ease: Cubic.easeOut
      },
      0.35
    )
  }

  componentWillUnmount() {
    const timeline = this.timeline
    if (timeline) {
      timeline.clear()
      timeline.pause(0)
    }
  }

  render() {
    return (
      <Container zIndex={this.props.zIndex}>
        <Cloud src={cloud2} innerRef={el => (this.cloud4 = el)} />
        <Cloud src={cloud3} innerRef={el => (this.cloud3 = el)} />
        <Cloud src={cloud1} innerRef={el => (this.cloud2 = el)} />
        <Cloud src={cloud4} innerRef={el => (this.cloud6 = el)} />
        <Cloud src={cloud5} innerRef={el => (this.cloud5 = el)} />
        <Cloud src={cloud6} innerRef={el => (this.cloud1 = el)} />
      </Container>
    )
  }
}

export default CloudsRasterized



// WEBPACK FOOTER //
// ./src/Kiosk/AttractLoopView/CloudsRasterized.js